<template>
<div class="tr_loading"><img src="../assets/images/loading.gif" align="center"></div>
</template>

<script>
import commonUtils from '@/js/workspace/common_util.js';
export default {
    mounted() {
        this.turnCloudExploer();
    },
    methods: {
        turnCloudExploer() { //通过callback参数，跳转到指定云盘管理页面
            var data = commonUtils.getQueryJSON()
            if(data){
                var code = data.code;
                var sourceData = JSON.parse(decodeURIComponent(window.atob(code)));
                this.$store.commit("setCatalogFileId",sourceData.fileId);
                this.$router.push({
                    name: "cloudExploer",
                    query: {
                        cloudType: sourceData.driveType,
                        folderId: sourceData.folderId,
                        folderName: sourceData.fileName,
                        tokenId: sourceData.driveId
                    }
                });
            }
        },
    }
}
</script>

<style>
.tr_loading {
    height: 100%;
    background: #E6EAF9;
    text-align: center;
    padding-top: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/extension_turn.vue